export const CONTACT = {
  phone: "+91 98960 14384",
  phone2: "+91 98133 84001",
  email: "scientificindustries86@mail.com",
  address: "Plot No. 104, 5 KM Bagla Road, Hisar",
  whatsapp: "+91 98960 14384",
  since: 1986,
};

export const PRODUCTS = [
  {
    id: "avs",
    index: "01",
    name: "Automatic Voltage Stabilizers",
    tag: "AVS / DIGITAL",
    desc: "Micro-controller driven correction that shields sensitive electronics from surges, sags and spikes — instant response, zero drama.",
    specs: ["±1% Output", "0.5s Response", "Wall / Floor Mount"],
    image: "https://images.unsplash.com/photo-1544724569-5f546fd6f2b5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "servo",
    index: "02",
    name: "Servo Voltage Stabilizers",
    tag: "SERVO / 3-PHASE",
    desc: "Heavy-duty servo-motor regulation for factories and hospitals. Precision voltage across brutal load swings, round the clock.",
    specs: ["Up to 2000 kVA", "Air / Oil Cooled", "±1% Accuracy"],
    image: "https://images.unsplash.com/photo-1558054665-fbe00cd7d920?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "solar",
    index: "03",
    name: "Solar Power Systems",
    tag: "SOLAR / HYBRID",
    desc: "On-grid, off-grid and hybrid arrays engineered end-to-end. Harvest the sun, slash the bill, own your energy.",
    specs: ["On / Off Grid", "MPPT Inverters", "25yr Panels"],
    image: "https://images.unsplash.com/photo-1724041875334-0a6397111c7e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "cooler",
    index: "04",
    name: "Water Coolers",
    tag: "COOLING / SS",
    desc: "Stainless-steel commercial coolers built to run hard in the hottest plants and busiest campuses without blinking.",
    specs: ["40–150 L/hr", "Food-Grade SS", "Storage + Instant"],
    image: "https://static.prod-images.emergentagent.com/jobs/efeb714f-8c47-4f38-bd4c-6930fff19728/images/7f67bd4c2fb89de6aec1cd886fedda2a183ce2bba5da9e63d0955ef5e8a0aed4.jpeg",
  },
  {
    id: "inverter",
    index: "05",
    name: "Inverter & Battery",
    tag: "BACKUP / POWER",
    desc: "Pure sine-wave inverters paired with deep-cycle batteries. Seamless backup that keeps the lights and lines alive.",
    specs: ["Pure Sine Wave", "Tubular Batteries", "Silent Switch"],
    image: "https://images.unsplash.com/photo-1732030373864-d37573915751?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "Engineered, not assembled",
    body: "Since 1986 every unit that leaves our floor is built by hands that understand load, heat and failure. No shortcuts, no rebadging — real engineering.",
  },
  {
    num: "02",
    title: "Power that never blinks",
    body: "Residential, commercial or heavy industrial — we design for the worst grid conditions so your operation runs like the grid was perfect.",
  },
  {
    num: "03",
    title: "Efficiency as a discipline",
    body: "From solar harvest to voltage correction, we obsess over every watt. Lower bills, lower carbon, longer equipment life — by design.",
  },
];

export const STATS = [
  { value: "38+", label: "Years in the field" },
  { value: "12k+", label: "Installations delivered" },
  { value: "2000", label: "kVA max capacity" },
  { value: "99.9%", label: "Uptime engineered" },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1703842737036-67d44089c1c9?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";
export const LEGACY_IMAGE =
  "https://images.unsplash.com/photo-1565954786194-d22abeaac3ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
export const CTA_IMAGE =
  "https://images.unsplash.com/photo-1785680334927-a451e9caa9df?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";
